import { render, staticRenderFns } from "./EditMenu.vue?vue&type=template&id=bbf55338&scoped=true"
import script from "./EditMenu.vue?vue&type=script&lang=js"
export * from "./EditMenu.vue?vue&type=script&lang=js"
import style0 from "./EditMenu.vue?vue&type=style&index=0&id=bbf55338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf55338",
  null
  
)

export default component.exports